import React from 'react'
// libs
import { Navigate } from 'react-router'
import { useRouter } from 'hooks/useRouter'
// components
import RiskAPI from 'containers/Risks/Risk/Edit/layers/API'
import RiskEdit from 'components/PageComponents/Risks/Edit'
import RiskTemplateAPI from 'containers/Risks/RiskTemplate/Edit/layers/API'
import RiskTransactions from 'containers/Risks/Risk/Edit/layers/RiskTransactions'

const RiskEditContainer = () => {
  const router = useRouter()

  // Notification emails link to one record while carrying the record to actually open. Redirecting
  // before the layers mount keeps the page from querying anything for the record being left.
  if (router.query.targetRiskId) {
    console.log('query', router.query)
    return (
      <Navigate replace to={`/forms/edit/${router.query.targetRiskId}/template/${router.query.targetTemplateId}`} />
    )
  }

  return (
    <RiskAPI key={router.query.id as string}>
      <RiskTemplateAPI>
        <RiskTransactions>
          <RiskEdit />
        </RiskTransactions>
      </RiskTemplateAPI>
    </RiskAPI>
  )
}

export default RiskEditContainer
